'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateField = require('./DateField');

var _DateField2 = _interopRequireDefault(_DateField);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CrossLinks = function (_Component) {
  _inherits(CrossLinks, _Component);

  function CrossLinks() {
    var _temp, _this, _ret;

    _classCallCheck(this, CrossLinks);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      crossLinks: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CrossLinks.prototype.componentDidMount = function componentDidMount() {
    this.getLinksData();
  };

  CrossLinks.prototype.getLinksData = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var crossLinks;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.props.getCrossLinks();

            case 2:
              crossLinks = _context.sent;
              this.setState({
                crossLinks: crossLinks
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getLinksData() {
      return _ref.apply(this, arguments);
    }

    return getLinksData;
  }();

  CrossLinks.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        LinkComponent = _props.LinkComponent;
    var crossLinks = this.state.crossLinks;
    if (!crossLinks || !crossLinks.length) return null;
    return _react2.default.createElement('div', {
      className: className
    }, _react2.default.createElement('div', {
      className: 'cross-links'
    }, _react2.default.createElement('div', {
      className: 'cross-links-header'
    }, 'Muista lehdist\xE4'), crossLinks.map(function (linkModel, i) {
      return _react2.default.createElement(LinkComponent, {
        key: i,
        to: {
          link: linkModel.link
        }
      }, _react2.default.createElement('div', {
        className: 'cross-link'
      }, _react2.default.createElement('div', {
        className: 'cross-link-image'
      }, _react2.default.createElement(_Image2.default, {
        data: {
          src: linkModel.thumbnail,
          alt: ''
        },
        size: ''
      })), _react2.default.createElement('div', {
        className: 'cross-link-title-area'
      }, _react2.default.createElement('h5', {
        className: 'cross-link-title'
      }, linkModel.title), _react2.default.createElement('div', {
        className: 'cross-link-meta'
      }, _react2.default.createElement('div', {
        className: 'cross-link-site'
      }, linkModel.siteName), _react2.default.createElement('div', {
        className: 'cross-link-divider'
      }, '|'), _react2.default.createElement('div', {
        className: 'cross-link-date-div'
      }, _react2.default.createElement(_DateField2.default, {
        date: linkModel.date,
        dateOnly: false
      }))))));
    })));
  };

  return CrossLinks;
}(_react.Component);

CrossLinks.propTypes = process.env.NODE_ENV !== "production" ? {
  getCrossLinks: _propTypes2.default.func.isRequired,
  LinkComponent: _propTypes2.default.any,
  className: _propTypes2.default.string
} : {};
exports.default = (0, _styledComponents2.default)(CrossLinks).withConfig({
  displayName: 'CrossLinks',
  componentId: 'sc-87wiyb-0'
})(['.cross-links{border:1px solid #d9dadc;.cross-links-header{height:42px;background-color:#000f5a;text-align:center;font-size:20px;color:white;line-height:42px;}.cross-link{padding:1rem;border-top:1px solid #f4f4f6;background:#fafafb;display:flex;flex-flow:row wrap;@media (min-width:1024px){flex-flow:row nowrap;}.cross-link-image{flex:0 0 auto;padding-right:1rem;img{width:100px;display:block;}}.cross-link-title-area{.cross-link-title{font-size:16px;line-height:20px;margin:0;display:inline;a:hover{color:#565e70;}}.cross-link-meta{color:#979797;font-size:12px;line-height:16px;margin:0.25rem 0 0 0;.cross-link-site{display:inline-block;text-transform:uppercase;color:#484e5d;}.cross-link-date-div{padding-left:0.5rem;padding-right:0.5rem;display:inline-block;}.cross-link-date{white-space:nowrap;}.cross-link-divider{padding-left:0.5rem;font-size:0.75rem;display:inline-block;}}}}}']);
module.exports = exports['default'];